module.exports = __webpack_public_path__ + "img/false.9201495d.svg";